export default (theme) => ({
  container: {
    width: 340,
    background: theme.palette.background.paper,
    height: "calc(var(--vh, 1vh) * 100)",
    position: "relative",
  },
  step: {
    padding: 16,
  },
});
